import { z } from 'zod'

/**
 * Why a session can end without the member asking: the API stopped accepting it (`expired`), it
 * sat untouched for longer than the platform allows (`idle`), which is a rule and not a fault, so
 * the sign-in screen says it differently, or the platform operator suspended the member's org
 * (`suspended`, the API's `org_suspended`), which only support can lift. Nothing ends a session
 * for idleness yet: the note is DealerDrive's, ready for when something does.
 */
export const ENDED_REASONS = ['expired', 'idle', 'suspended'] as const

export type EndedReason = (typeof ENDED_REASONS)[number]

/**
 * The sign-in route's search: where to go back to, and why the member is here when they did not
 * come on purpose. Anything else in the address is dropped rather than refused.
 */
export const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
  reason: z.enum(ENDED_REASONS).optional().catch(undefined),
})

export type LoginSearch = z.output<typeof loginSearchSchema>

/** Where to come back to after signing in. The home screen needs no parameter. */
export function returnTo(href: string): string | undefined {
  return href === '/' ? undefined : href
}
